import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

export const getSurveys = async (category) => {
    const params = category && category !== 'الكل' ? { category } : {};
    const { data } = await api.get('/surveys', { params });
    return data;
};

export const getCategories = async () => {
    const { data } = await api.get('/categories');
    return data.categories;
};

export const adminLogin = async (password) => {
    const { data } = await api.post('/admin/login', { password });
    return data.token;
};

const authHeaders = (token) => ({
    headers: { Authorization: `Bearer ${token}` },
});

export const createSurvey = async (token, payload) => {
    const { data } = await api.post('/surveys', payload, authHeaders(token));
    return data;
};

export const updateSurvey = async (token, id, payload) => {
    const { data } = await api.put(`/surveys/${id}`, payload, authHeaders(token));
    return data;
};

export const deleteSurvey = async (token, id) => {
    const { data } = await api.delete(`/surveys/${id}`, authHeaders(token));
    return data;
};

export const getVisitors = async (token) => {
    const [{ data: log }, { data: summary }] = await Promise.all([
        api.get('/admin/visits', authHeaders(token)),
        api.get('/admin/visits/summary', authHeaders(token)),
    ]);
    return { log, summary: summary.items };
};
